import Router from "next/router";
import Script from "next/script";
import { useState } from "react";
import { useSession } from "next-auth/react";
import ContactUsAdminBackground from "@/admin/molecules/ContactUsAdminBackground";
import LoadingState from "@/sharedComponents/atoms/LoadingState";
import { tawkLink } from "src/services/connection";
import HomeHeader from "src/pages/seoComponent";

function AboutUs(): JSX.Element {
  const { status } = useSession();
  const [contactSubmitted, setContactSubmitted] = useState(false);

  if (status === "authenticated") {
    Router.replace(
      {
        pathname: "/admin-portal/course-manager/all-courses",
      },
      "/admin-portal/course-manager/all-courses"
    );
  } else {
    return (
      <>
        <HomeHeader title="Contact Us" />

        <div
          className={`w-full h-screen ${
            contactSubmitted ? "overflow-hidden" : ""
          }`}
        >
          <Script strategy="lazyOnload" src={tawkLink} />
          <ContactUsAdminBackground modalIsOpen={setContactSubmitted} />
        </div>
      </>
    );
  }
  return (
    <div className="flex place-content-center h-screen">
      <LoadingState />
    </div>
  );
}

export default AboutUs;
